var Theme = Theme || {};

Theme.MeetingAbstractIssue = (function ($) {
    var baseSiteUrl = $('#hfSiteURL').val();
    var ajaxRequestsRunning = 0;
    var issueId = 0;
    var expandClass = 'icon-general_arrow-right';
    var expandSelector = `.${expandClass}`;
    var collapseClass = 'icon-general_arrow-down';
    var collapseSelector = `.${collapseClass}`;

    return {
        init: _init
    };

    function _init() {
        issueId = $('#hdnIssueId').val();
        bindCategoryAjax();
        bindShowAll();
    }

    function bindShowAll() {
        $('.js-show-all-toggle').on('click', function (e) {
            e.preventDefault();
            if ($(expandSelector).length) {
                _expandAll();
            }
            else {
                _collapseAll();
            }
        });
    }

    function _expandAll() {
        $('.js-cat-toggle').each(function() {
            if ($(this).find(expandSelector).length) {
                _toggleCategory($(this), true);
            }
        });
    }

    function _collapseAll() {
        $('.js-cat-toggle').each(function() {
            if ($(this).find(collapseSelector).length) {
                _toggleCategory($(this));
            }
        });
    }

    function bindCategoryAjax() {
        $(document.body).on('click', '.js-cat-toggle', function (e) {
            let $currTarget = $(e.currentTarget);
            e.preventDefault();
            _toggleCategory($currTarget);
        });
    }

    // $parentContainer: element with class .js-cat-toggle
    function _toggleCategory($parentContainer, autoExpand) {
        let $childContainer = $parentContainer.siblings('.js-children-category-container');
        let $toggleIcon = $parentContainer.find('.js-toggle-icon');
        if ($toggleIcon.hasClass(expandClass)) {
            _checkForAjax($parentContainer, $childContainer, autoExpand);
            $childContainer.show();
            $toggleIcon.removeClass(expandClass);
            $toggleIcon.addClass(collapseClass);
        }
        else {
            $parentContainer.find('.js-children-category-container').hide();
            $childContainer.hide();
            $toggleIcon.removeClass(collapseClass);
            $toggleIcon.addClass(expandClass);
        }

    }

    // Check to see if we need to fetch content through ajax.
    // $parentContainer: element with class .js-cat-toggle
    // $childContainer: element with class .js-children-category-container
    function _checkForAjax($parentContainer, $childContainer, autoExpand) {
        if (!$childContainer.children().length) {
            let headingId = $parentContainer.data('id');
            let headingTypeId = $parentContainer.data('headingtypeid');
            let ajaxUrl = `//${baseSiteUrl}/IssueVolume/MeetingAbstractIssueChildHeadings`;
            let ajaxData = {
                headingId: headingId,
                issueId: issueId,
                headingTypeId: headingTypeId
            };

            _startAjax();
            SCM.Ajax.get(ajaxUrl, ajaxData)
                .expectHtml()
                .then(_populateCategoryContent)
                .catch(console.error)
                .finally(_finishAjax);
        }

        function _populateCategoryContent(ajaxResult) {
            $childContainer.html(ajaxResult);
            SCM.Utilities.LazyLoad.init('lazy');
            if (autoExpand === true) {
                $childContainer.find('.js-cat-toggle').each(function () {
                    _toggleCategory($(this));
                });
            }
        }
    }

    function _startAjax() {
        ajaxRequestsRunning++;
        $('body').addClass('wait');
    }

    function _finishAjax() {
        ajaxRequestsRunning--;
        if (ajaxRequestsRunning <= 0) {
            $('body').removeClass('wait');
        }
    }

})(jQuery);
